import { SxProps, Typography } from '@mui/material';
import React from 'react';
import EllipsisLoader from './EllipsisLoader';

type CentralDataCardStatProps = {
    data?: string;
    paragraphDetail?: string;
    sx?: SxProps;
};

const CentralDataCardStat: React.FunctionComponent<CentralDataCardStatProps> = function ({
    data,
    paragraphDetail,
    sx,
}: CentralDataCardStatProps) {
    return (
        <>
            <Typography
                sx={{
                    fontSize: '18px',
                    textAlign: 'center',
                }}
            >
                {paragraphDetail}
            </Typography>
            <Typography
                component="h2"
                sx={{
                    fontSize: '32px',
                    textAlign: 'center',
                    ...sx,
                }}
            >
                <b>{data || <EllipsisLoader sx={{ ...sx }} />}</b>
            </Typography>
        </>
    );
};

export default CentralDataCardStat;
